<div class="container scroll-bar" [ngClass]="{ 'light-mode': !isDarkMode(), 'dark-mode': isDarkMode() }">

  <p class="title">
    Environmental Performance Module
    <mat-icon class="titleIcon">chevron_right</mat-icon> EU ETS
    <mat-icon class="titleIcon">chevron_right</mat-icon> EU ETS Inside View
  </p>

  <p class="header" *ngIf="paginatedData.length > 0">
    {{ vesselName }}
  </p>

  <div class="filter-header" style="margin-top: 25px;">
    <form [formGroup]="myreportForm" class="filter-flex-container">

      <!-- Voyage Number -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>Voyage No</mat-label>
        <input matInput formControlName="vesselname" placeholder="Enter Voyage No">
      </mat-form-field>

      <!-- Dates -->
      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="from_date" placeholder="Select Date">
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="compact-field">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="toPicker" formControlName="to_date" placeholder="Select Date">
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <button mat-flat-button color="warn" class="fetch-btn clear-btn" (click)="clearClick()">
        Clear
      </button>

      <button mat-flat-button color="primary" class="fetch-btn" (click)="filterClick()">
        Apply Filter
      </button>

    </form>
  </div>

  <div class="table-container scroll-bar" [ngClass]="{ 'dark-table': isDarkMode() }">
    <table class="mat-elevation-z8 printable-table" id="style-4" matSort>

      <thead class="sticky-header">
        <!-- MAIN HEADER -->
        <tr>
          <th rowspan="3">S.No</th>
          <th rowspan="3">Voyage No</th>
          <th rowspan="3">Segment</th>
          <th rowspan="3">Condition</th>

          <th rowspan="3">From Port</th>
          <th rowspan="3">Unberth/Berth (Date & Time - UTC)</th>
          <th rowspan="3">EU Port</th>

          <th colspan="5" class="text-center">Bunker ROB at Departure</th>

          <th rowspan="3">Cargo Qty</th>

          <th rowspan="3">To Port</th>
          <th rowspan="3">Berth/Unberth (Date & Time - UTC)</th>
          <th rowspan="3">EU Port</th>

          <th colspan="5" class="text-center">Bunker ROB at Arrival</th>

          <th rowspan="3">Operation</th>

          <th colspan="5" class="text-center">Fuel Consumed</th>

          <!-- <th rowspan="3">EU ETS Penalty (€)</th> -->
          <!-- <th rowspan="2">Operation</th> -->

          <th colspan="4" class="th-text-center">Emission (MT)</th>
        </tr>

        <!-- SUB HEADER -->
        <tr class="sub-header rob-sub">
          <!-- ROB Departure -->
          <th>HFO</th>
          <th>LFO</th>
          <th>DO</th>
          <th>LNG</th>
          <th>Biofuel</th>

          <!-- ROB Arrival -->
          <th>HFO</th>
          <th>LFO</th>
          <th>DO</th>
          <th>LNG</th>
          <th>Biofuel</th>

          <!-- Fuel Consumed -->
          <th>HFO</th>
          <th>LFO</th>
          <th>DO</th>
          <th>LNG</th>
          <th>Biofuel</th>

          <!-- Emission -->
          <th>CO₂</th>
          <th>N₂O</th>
          <th>CH₄</th>
          <th>TOTAL</th>
        </tr>
      </thead>

      <tbody>
        <!-- Skeleton Loading -->
        <ng-container *ngIf="isLoading; else dataRows">
          <tr *ngFor="let i of [1,2,3,4,5]">
            <td colspan="32">
              <div class="skeleton-table-row skeleton"></div>
            </td>
          </tr>
        </ng-container>

        <ng-template #dataRows>
          <tr *ngFor="let element of paginatedData; let i = index">
            <td>{{ i + 1 }}</td>

            <!-- Voyage & Segment -->
            <td>{{ element.vyg_num || element.meraki_voyage_number || element.voyage_number || '-' }}</td>
            <td>{{ element.segment_type || '-' }}</td>
            <td>{{ element.vessel_condition || '-' }}</td>

            <!-- Start Port details -->
            <td>{{ element.from_port || '-' }}</td>
            <td>{{ element.departure_time ? (element.departure_time | date:'dd/MM/yyyy HH:mm':'UTC') : '-' }}</td>
            <td>{{ element.from_is_eu == true ? 'Yes': 'No' }}</td>

            <!-- ROB Departure -->
            <td>{{ element.rob_start_hfo || '-' }}</td>
            <td>{{ Number(element.rob_start_vlsfo || 0) + Number(element.rob_start_ulsfo || 0) }}</td>
            <td>{{ element.rob_start_mgo || '-' }}</td>
            <td>{{ element.rob_start_lng || '-' }}</td>
            <td>{{ element.rob_start_biofuel || '-' }}</td>

            <td>{{ (element.cargo_qty | number:'1.0-0') || '-' }}</td>

            <!-- End Port Details -->
            <td>{{ element.to_port || '-' }}</td>
            <td>{{ element.to_port && element.arrival_time ? (element.arrival_time | date:'dd/MM/yyyy HH:mm':'UTC') :
              '-' }}</td>
            <td>{{ element.to_is_eu == true ? 'Yes': element.to_port ? 'No' : '-' }}</td>

            <!-- ROB Arrival -->
            <td>{{ element.rob_end_hfo || '-' }}</td>
            <td>{{ (Number(element.rob_end_vlsfo || 0) + Number(element.rob_end_ulsfo || 0)) || '-' }}</td>
            <td>{{ element.rob_end_mgo || '-' }}</td>
            <td>{{ element.rob_end_lng || '-' }}</td>
            <td>{{ element.rob_end_biofuel || '-' }}</td>

            <td>{{ (element.vessel_purpose | titlecase) || '-' }}</td>

            <!-- Fuel Consumed -->
            <td>{{ +element.cons_hfo ? (element.cons_hfo | number:'1.2-2') : '-' }}</td>
            <td>{{ +(Number(element.cons_ulsfo || 0) + Number(element.cons_vlsfo || 0)) ? ((Number(element.cons_ulsfo ||
              0) + Number(element.cons_vlsfo || 0)) | number:'1.2-2') : '-' }}</td>
            <td>{{ +element.cons_mgo ? (element.cons_mgo | number:'1.2-2') : '-' }}</td>
            <td>{{ +element.cons_lng ? (element.cons_lng | number:'1.2-2') : '-' }}</td>
            <td>{{ +element.cons_biofuel ? (element.cons_biofuel | number:'1.2-2') : '-' }}</td>

            <td>{{ element.co2_mt || '-' }}</td>
            <td>{{ element.n2o_mt || '-' }}</td>
            <td>{{ element.ch4_mt || '-' }}</td>
            <td>{{ element.total_emissions_mt || '-' }}</td>
          </tr>

          <!-- No Data State -->
          <tr *ngIf="paginatedData.length === 0">
            <td colspan="32" style="text-align: center; padding: 20px; color: #718096;">
              No voyage data available for the selected filters.
            </td>
          </tr>
        </ng-template>
      </tbody>

    </table>
  </div>

  <mat-paginator [length]="elements.length" [pageSize]="itemsPerPage" [pageSizeOptions]="[100]"
    (page)="onPageChange($event)" [ngClass]="{ 'dark-paginator': isDarkMode() }" showFirstLastButtons>
  </mat-paginator>

  <div class="bottom-navigator">
    <div class="nav-arrow" matTooltip="Go Back to EU ETS Table" matTooltipPosition="above" (click)="goBack()">
      ←
    </div>
  </div>

</div>

<br />